import React, { useEffect, useState } from "react";
import { Col, Row, Form } from "react-bootstrap";
import { getSessionId } from "../../../utils/tokenHandlers";
// import { getBankAccountType } from "../../../feature/apis/listOfValues/getBankAccountType";
import { getFinancierTypeFgn } from "../../../feature/apis/listOfValues/getFinancierTypeFgn";

interface FinancierTypeFgnProps {
  name: string;
  label: string;
  register: any;
  required?: boolean;
  requiredMessage?: string;
  handleChange?: () => JSX.Element;
  defaultValue?: string;
  error?: string;
}

interface FinancierTypeFgnData {
  sr_no: number;
  lov_type: string;
  lov_display_value: string;
  lov_value: string;
  is_active: boolean;
}

const FinancierTypeFgn: React.FC<FinancierTypeFgnProps> = ({
  name,
  label,
  register,
  required,
  requiredMessage = "This field is required",
  handleChange,
  defaultValue,
  error,
}) => {
  const token = getSessionId();

  const [financierTypeIndiaValues, setFinancierTypeFgnValues] = useState<
    FinancierTypeFgnData[]
  >([]);

  useEffect(() => {
    getFinancierTypeFgn(token).then((response) => {
      setFinancierTypeFgnValues(response.result.result);
    });
  }, []);

  return (
    <Form.Group as={Col} className="mb-3">
      <Row className="align-items-center">
        <Form.Label column md={4}>
          <span className="float-end">
            {label}{" "}
            <span className="text-danger form-label">
              {required ? "*" : ""}
            </span>{" "}
            :
          </span>
        </Form.Label>
        <Col md={8}>
          <Form.Select
            as="select"
            className={`custom-input form-control ${error ? "is-invalid" : ""}`}
            onChange={handleChange}
            {...register(name, {
              required: required ? requiredMessage : false,
            })}
            defaultValue={defaultValue}
          >
            <option value="">Select Option</option>
            {financierTypeIndiaValues.map((financierTypeIndiaValue, index) => (
              <option key={index} value={financierTypeIndiaValue.lov_value}>
                {financierTypeIndiaValue.lov_display_value}
              </option>
            ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="align-items-center">
        <Col md={4}></Col>
        <Col md={8}>{error && <p className="m-0 err-msg">{error}</p>}</Col>
      </Row>
    </Form.Group>
  );
};

export default FinancierTypeFgn;
